import { PAGES, type Page } from '@agrogruda/shared';

/** Route per prototype page id (ARCHITECTURE.md §3.1). */
export const PAGE_PATHS: Readonly<Record<Page, string>> = {
  dashboard: '/',
  sales: '/sales',
  purchases: '/purchases',
  suppliers: '/suppliers',
  stock: '/stock',
  debts: '/debts',
  tasks: '/tasks',
  whatsapp: '/whatsapp',
  attendance: '/attendance',
  reports: '/reports',
  deliveries: '/deliveries',
  settings: '/settings',
};

/** Sidebar order = PAGES order (prototype lines 904-933). */
export const NAV_PAGES: readonly Page[] = PAGES;

export function pageFromPath(pathname: string): Page {
  for (const page of PAGES) {
    const path = PAGE_PATHS[page];
    if (path === '/') continue;
    if (pathname === path || pathname.startsWith(`${path}/`)) return page;
  }
  return 'dashboard';
}
